<style lang="scss">
  .pagination-group {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px;
  }
</style>

<script>
  import Pagination from "./Pagination.svelte";
  import PaginationLength from "./PaginationLength.svelte";
  import Results from "./Results.svelte";
  import StepPagination from "./StepPagination.svelte";

  let {
    start = $bindable(0),
    total = 0,
    length = $bindable(10),
    skeleton = false,
    class: cls = "",
    style = "",
    clientHeight = $bindable(),
    stepPagination = false,
    hidePaginationLength = false,
  } = $props();

  let pageCount = $derived(Math.ceil(total / length));

  let page = $derived(Math.floor(start / length) + 1);
  const getPage = () => page;
  const setPage = (p) => {
    start = (p - 1) * length;
  };
  const getLength = () => length;
  const setLength = (l) => {
    length = l;
    setPage(1 + Math.floor(start / length));
  };

  let dynamicPageNumbers = $derived.by(() => {
    let pages = [page - 1, page, page + 1];
    if (page <= 2) {
      pages = [2, 3, 4];
    } else if (page === pageCount - 1) {
      pages = [page - 2, page - 1, page];
    } else if (page === pageCount) {
      pages = [page - 3, page - 2, page - 1];
    }
    return pages.filter((p) => p > 1 && p < pageCount);
  });
  let pageNumbers = $derived(
    total === 0 || pageCount === 1 ? [1] : [1, ...dynamicPageNumbers, pageCount]
  );
</script>

<div class="pagination-group {cls}" {style} bind:clientHeight>
  <Results {start} {total} {length} {skeleton} />
  {#if stepPagination}
    <StepPagination bind:page={getPage, setPage} {pageCount} />
  {:else}
    <Pagination bind:page={getPage, setPage} {pageNumbers} />
  {/if}
  {#if hidePaginationLength}
    <!-- Empty div to maintain space-between alignment -->
    <div></div>
  {:else}
    <PaginationLength bind:value={getLength, setLength} />
  {/if}
</div>
